import auth from '@/router/auth'
import CategoryBlogIndex from '@/components/attribute-keys/Index'
import CategoryBlogCreate from '@/components/attribute-keys/Create'
import CategoryBlogUpdate from '@/components/attribute-keys/Update'
import CategoryBlogShow from '@/components/attribute-keys/Show'

export default [
  {
    path: '/attribute-keys',
    name: 'attribute-keys-index',
    component: CategoryBlogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/attribute-keys/create',
    name: 'attribute-keys-create',
    component: CategoryBlogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/attribute-keys/update/:id',
    name: 'attribute-keys-update',
    component: CategoryBlogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/attribute-keys/show/:id',
    name: 'attribute-keys-show',
    component: CategoryBlogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/attribute-keys/router.js